import React, { useState } from 'react';
import { FiEdit, FiTrash2, FiToggleLeft, FiToggleRight } from 'react-icons/fi';
import './TipoClienteList.css';

const TipoClienteList = ({ tiposCliente, onSelectTipo, selectedId, onEdit, onDelete, onToggleStatus }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  // Get user role from localStorage
  const userType = localStorage.getItem('userType') || '';
  const isMaster = userType === 'master';
  
  // Ensure tiposCliente is an array before filtering
  const tiposArray = Array.isArray(tiposCliente) ? tiposCliente : [];
  
  const filteredTipos = tiposArray.filter(tipo => 
    tipo?.nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    tipo?.servicos?.some(servico => 
      servico?.nome?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'N/A';
      
      return date.toLocaleDateString('pt-BR');
    } catch (error) {
      return 'N/A';
    }
  };

  // Helper function to format currency
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  return (
    <div className="clientes-list-container">
      <div className="search-container">
        <input
          type="text"
          placeholder="Buscar tipos de cliente..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
      {filteredTipos.length === 0 ? (
        <div className="no-results">
          {searchTerm 
            ? "Nenhum tipo de cliente encontrado para esta busca" 
            : "Não há tipos de cliente cadastrados"}
        </div>
      ) : (
        <table className="clientes-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Serviços</th>
              <th>Status</th>
              <th>Data de Cadastro</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredTipos.map((tipo, index) => (
              <tr 
                key={tipo._id || index}
                className={selectedId === tipo._id ? 'selected-row' : ''}
                onClick={() => onSelectTipo(tipo)}
              >
                <td>
                  <strong>{tipo.nome || 'Tipo sem nome'}</strong>
                </td>
                <td>
                  {tipo.servicos && tipo.servicos.length > 0 ? (
                    <div className="servicos-list-cell">
                      {tipo.servicos.map((servico, idx) => (
                        <span key={idx} className="servico-badge">
                          {servico.nome} ({formatCurrency(servico.valor)})
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span className="no-servicos-text">Nenhum serviço cadastrado</span>
                  )}
                </td>
                <td>
                  <span className={`status-badge ${tipo.ativo ? 'status-ativo' : 'status-inativo'}`}>
                    {tipo.ativo ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td>{formatDate(tipo.createdAt)}</td>
                <td>
                  <div className="action-buttons">
                    {/* Edit button */}
                    <button 
                      className="edit-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        if(typeof onEdit === 'function') {
                          onEdit(tipo);
                        }
                      }}
                      title="Editar"
                    >
                      <FiEdit />
                    </button>
                    
                    {/* Toggle status button */}
                    <button 
                      className="toggle-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        if(typeof onToggleStatus === 'function') {
                          onToggleStatus(tipo._id);
                        }
                      }}
                      title={tipo.ativo ? 'Desativar' : 'Ativar'}
                    >
                      {tipo.ativo ? <FiToggleRight /> : <FiToggleLeft />}
                    </button>
                    
                    {/* Delete button - only for Master role */}
                    {isMaster && (
                      <button 
                        className="delete-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          if(typeof onDelete === 'function') {
                            onDelete(tipo._id);
                          }
                        }}
                        title="Excluir"
                      >
                        <FiTrash2 />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TipoClienteList;
